import React from "react";
import "./Usp.css";

interface UspProps {
  label: string;
  title: string;
  description: string;
  imageSrcMobile: string;
  imageSrcDesktop: string;
  purple?: boolean;
}

const Usp: React.FC<UspProps> = ({
  label,
  title,
  description,
  imageSrcMobile,
  imageSrcDesktop,
  purple = false,
}) => {
  return (
    <div>
      <div
        className="usp-container display-desktop"
        style={{
          backgroundImage: `url(${imageSrcDesktop})`,
          backgroundColor: purple ? "#E5E9FE" : "#FFFFFF",
        }}
      >
        <div
          className="usp-content"
          style={{
            marginRight: purple ? "3%" : "57%",
            marginLeft: purple ? "59%" : "5%",
          }}
        >
          <p className="label-regular mb-2 purple">{label}</p>
          <h1 className="mb-3">{title}</h1>
          <p>{description}</p>
        </div>
      </div>
      <div
        className="usp-container display-mobile"
        style={{ backgroundColor: purple ? "#E5E9FE" : "#FFFFFF" }}
      >
        <div className="usp-content">
          <p className="label-regular mb-2 purple">{label}</p>
          <h1 className="mb-3">{title}</h1>
          <p>{description}</p>
        </div>
        <img alt="Feature" src={imageSrcMobile} className="rounded-3xl" />
      </div>
    </div>
  );
};
export default Usp;
